<template>
    <!--      action="http://service.it-ot.cn/plastic/custom/genCert/uploadZipFile"-->

    <div class="hello">
        <el-upload
                v-loading="loading"
                class="upload-demo"
                drag
                :before-upload="beforeAvatarUpload"
                :on-success="uploadSuccess"
                :action="uploadUrl"
                multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip" style="font-size: 18px">只能上传zip格式的压缩包文件，且不超过10M</div>
        </el-upload>
    </div>
</template>

<script>
    export default {
        name: 'uploadFile',
        data() {
            return {
                uploadUrl: window.SITE_CONFIG['baseUrl'] + "/custom/genCert/uploadZipFile",
                loading: false,
                msg: 'Welcome to Your Vue.js App'
            }
        },

        methods: {
            beforeAvatarUpload(file) {

                // const isZip = (file.type === 'zip') || (file.type === 'application/zip') || (file.type === 'application/x-zip-compressed');
                // const isZip = (file.type === 'rar') || (file.type === 'application/rar') || (file.type === 'application/x-rar-compressed'
                //     || (file.type === 'application/x-rar'));

                const isZip = file.name.endsWith(".zip")

                console.log(file, isZip, 999)
                const isLt100M = file.size / 1024 / 1024 < 50;

                if (!isZip) {
                    this.$message.error('上传头像压缩包文件只能是zip格式');
                }
                if (!isLt100M) {
                    this.$message.error('上传文件不能超过 50MB!');
                }

                let ret = isZip && isLt100M
                if (ret) {
                    this.loading = true
                }
                return isZip && isLt100M;
            },

            uploadSuccess() {
                this.loading = false
                this.$alert('点击关闭窗口', '文件已上传成功！', {
                    confirmButtonText: '确定',
                    callback: action => {
                        window.close();
                    }
                });
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>



// WEBPACK FOOTER //
// src/components/uploadFile.vue